//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            item: [],
            loading: true
        };
    },
    created: function created() {
        Event.$on('reverse-billing-job-confirmed', this.reverseJobConfirmed);
        Event.$on('show-ar-billing', this.showBilling);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('reverse-billing-job-confirmed');
        Event.$off('show-ar-billing');
    },
    mounted: function mounted() {},

    methods: {
        showBilling: function showBilling(item) {
            var _this = this;

            Object.assign(this.$data, this.$options.data());
            this.$children[0].$data.showModal = true;

            axios.get('/prototype/accounting/accounts-receivable/ar-billing-job/' + item.id).then(function (response) {
                _this.item = response.data;
                _this.loading = false;
            });
        },
        reverseJob: function reverseJob() {
            if (window.user.role == "super-admin") {
                Event.$emit("confirm-delete", this.item, '/prototype/accounting/accounts-receivable/billings/reverse', "reverse-billing-job-confirmed", 'Are you ABSOLUTELY sure?\n                This will reverse ' + this.item.transactions.length + ' resident transactions.\n                It will require developer interaction to re-run the billing if you are past the first day of the\n                billing month.', "Yes, Reverse this billing job");
            } else {
                this.$snotify.info("Please contact corporate to reverse this billing job.");
            }
        },
        reverseJobConfirmed: function reverseJobConfirmed() {
            this.$snotify.info('This billing job will be reversed in a few minutes. Check back later.');
            Event.$emit('refresh-billing-list');
            Event.$emit('close-full-modal');
        }
    },
    computed: {
        isSuperAdmin: function isSuperAdmin() {
            return window.user.role == 'super-admin';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-receivable/billings/ArViewBilling.vue
// module id = n+04
// module chunks = 0 1